export default __webpack_public_path__ + "static/media/top-desk-view.d420751c.jpg";